/* eslint-disable @typescript-eslint/no-explicit-any */
/* Сложные типы здесь, оставлю any */
import type { CancellationReasonsValidated } from '@lt/api/dist/methods/orders/types';

export enum CancelRequestStatus {
  UNDEFINED,
  SUCCESS,
  FAILED,
}

export interface CancellationReasons {
  reasons: CancellationReasonsValidated[];
  refundText: string | null;
  refundTitle: string | null;
  paid: boolean;
  refundToken: string;
}
export interface IOrder {
  info: any;
  cancellationReasons: CancellationReasons;
  selectedCancelReason?: CancellationReasonsValidated;
  cancellRequestStatus: CancelRequestStatus;
  changesRequestStatus: CancelRequestStatus;
  changes: any;
  customReasonText: string;
  changesTouristsRequestStatus: CancelRequestStatus;
  requestStatusText: string;
  requestStatusTitle: string;
}
